export const FETCH_REFERRERS = 'src/AdminReferrers/FETCH_REFERRERS';
export const FETCH_REFERRERS_SUCCESS = 'src/AdminReferrers/FETCH_REFERRERS_SUCCESS';
export const FETCH_REFERRERS_FAILURE = 'src/AdminReferrers/FETCH_REFERRERS_FAILURE';
export const APPROVE_REFERRER = 'src/AdminReferrers/APPROVE_REFERRER';
export const APPROVE_REFERRER_SUCCESS = 'src/AdminReferrers/APPROVE_REFERRER_SUCCESS';
export const APPROVE_REFERRER_FAILURE = 'src/AdminReferrers/APPROVE_REFERRER_FAILURE';
export const DEACTIVATE_REFERRER = 'src/AdminReferrers/DEACTIVATE_REFERRER';
export const DEACTIVATE_REFERRER_SUCCESS = 'src/AdminReferrers/DEACTIVATE_REFERRER_SUCCESS';
export const DEACTIVATE_REFERRER_FAILURE = 'src/AdminReferrers/DEACTIVATE_REFERRER_FAILURE';
